// Every W-9 link goes through these helpers with the viewer's route prefix
// (hooks/useAdminRouteContext), so the section works under /admin today
// and /admin-track or /admin-employee later (w9-plan §6.1). The query
// string is the section's state: ?account=<id>&year=<yyyy|all>
// &filter=notback&entry=<id>.

const query = (params) => {
  const parts = Object.keys(params)
    .filter(
      (k) => params[k] !== undefined && params[k] !== null && params[k] !== ''
    )
    .map((k) => `${k}=${encodeURIComponent(params[k])}`);
  return parts.length ? `?${parts.join('&')}` : '';
};

// `${prefix}/w9?account=12&year=2026&filter=notback&entry=45`
export const w9DashboardPath = (
  prefix,
  { account, year, filter, entry } = {}
) => `${prefix}/w9${query({ account, year, filter, entry })}`;

// `${prefix}/w9/link?account=12`
export const w9LinkPath = (prefix, { account } = {}) =>
  `${prefix}/w9/link${query({ account })}`;

// `${prefix}/w9/settings?account=12`
export const w9SettingsPath = (prefix, { account } = {}) =>
  `${prefix}/w9/settings${query({ account })}`;

// The query string → { account, year, filter, entry } (numbers where the
// URL holds an id; `year` stays 'all' or a number; missing → null).
export const readW9Params = (search) => {
  const params = new URLSearchParams(search || '');
  const int = (key) => {
    const n = parseInt(params.get(key), 10);
    return n > 0 ? n : null;
  };
  const year = params.get('year');
  return {
    account: int('account'),
    year: year === 'all' ? 'all' : int('year'),
    filter: params.get('filter') === 'notback' ? 'notback' : null,
    entry: int('entry'),
  };
};
